import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'
import Traduction from 'Components/Traduction'
import Upload from 'Components/Upload'
import Constants from 'EurestoFonction/Constants'
import React from 'react'


export default class SaisieLibreMultipleDocument extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Title inline={this.props.inline} style={{padding: '5px 0'}} title={this.props.title} buttons={!this.props.disabled &&<button type="button" onClick={this.props.onClickSaisieLibreMultipleBool}
                                                       disabled={this.props.disabled || false}
                                                       className="text-success ei-commun_ajouter"
                                                       style={{display: 'inline-block', marginLeft: 5}}/>}>

        {
          (this.props.data !== undefined ? this.props.data : []).map((data, index) => (

            <Grid key={index} container style={{margin: 0, padding: 0}} spacing={0} justify={'center'}
                  alignItems={'center'}>
              {this.props.client_id && <Grid item style={{margin: 0, padding: 0}}>
                <Upload disabled={this.props.disabled || false} media_id={data.valeur_entier} link={data.media_lien} client_id={this.props.client_id} onChange={(r) => this.props.onChangeUploadSaisieLibreMultipleUpload(index, r.id, r.lien)} />
              </Grid> }
              <Grid item xs style={{margin: 0, padding: 0}}>
                <Traduction style={this.props.style}
                  onChange={(e) => this.props.onChangeSaisieLibeMultipleBool(e, index)}
                  name={'text'}
                  disabled={this.props.disabled || false}
                  data={data.text !== undefined ? data.text : []}
                  type={Constants.typeSaisie.SaisieLibre}
                />
              </Grid>
              <Grid item>
                <button type="button" onClick={() => this.props.onClickRemoveSaisieLibreMultipleBool(index)}
                        className="text-danger ei-commun_enlever"
                        disabled={this.props.disabled || false}/>
              </Grid>
            </Grid>
          ))
        }
      </Title>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/SaisieLibre/SaisieLibreMultipleDocument.js